import { useTranslation } from 'react-i18next';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function AccountCard() {
  const { t } = useTranslation('settings');
  const { user, logout } = useAuth();
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('account.title')}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2 text-sm">
        <div>
          <span className="text-muted-foreground">{t('account.username')}:</span>{' '}
          {user?.username ?? '—'}
        </div>
        <div>
          <span className="text-muted-foreground">{t('account.via')}:</span>{' '}
          {user?.authenticated_via === 'cookie'
            ? t('account.viaCookie')
            : t('account.viaApiKey')}
        </div>
        <Button variant="outline" size="sm" onClick={() => void logout()}>
          {t('account.logout')}
        </Button>
      </CardContent>
    </Card>
  );
}
